import DOMPurify from 'dompurify';
import type {DirectiveBinding} from 'vue';

/**
 * Drop-in replacement for v-html that sanitizes the value through DOMPurify (standard
 * HTML profile) before insertion. All CMS/BE-provided rich text must render through
 * this directive; raw v-html is banned via vue/no-v-html. Our content is authored in
 * the internal Directus CMS by trusted editors, so this is defense in depth for the
 * medical-device surface (a compromised CMS account must not become stored XSS), not
 * a functional filter — the profile keeps every tag the content actually uses.
 */
export const safeHtml = (el: HTMLElement, binding: DirectiveBinding<string | null | undefined>): void => {
  if (binding.value === binding.oldValue) {
    return;
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention -- DOMPurify API shape
  el.innerHTML = DOMPurify.sanitize(binding.value ?? '', {USE_PROFILES: {html: true}});
};
